import { render, staticRenderFns } from "./box-leads.vue?vue&type=template&id=1d8426ca&"
import script from "./box-leads.vue?vue&type=script&lang=js&"
export * from "./box-leads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports